import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { CommonService } from '../../../services/common/common.service';
import { ToolsService } from '../../../services/tools/tools.service';
import { Column } from '../../interfaces/column.interface';
import { MenusDataService, MenusColumnsService } from '../../services';
import { DialogMenuFormComponent } from './menu-form/menu-form.component';
import { DialogMenuDetailsComponent } from './menu-details/menu-details.component';
import { Menu, MenusResult } from '../../interfaces';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.scss'],
  providers: [MessageService, ConfirmationService, DialogService],
})
export class MenusComponent implements OnInit, OnDestroy {

  private menuAddDialog: DynamicDialogRef = new DynamicDialogRef();
  private menuEditDialog: DynamicDialogRef = new DynamicDialogRef();
  private menuDetailsDialog: DynamicDialogRef = new DynamicDialogRef();
  public menuToDelete: Menu = {};
  public menus: Menu[] = [];
  public menu: Menu = {};
  public selectedMenus: Menu[] = [];
  public submitted: boolean = false;
  public parameters: { [param: string]: string | string[] } = { offset: '0', limit: '100' };
  public chunkSize: number = 200;
  public columns: Column[] = [];
  public isLoading: boolean = false;
  public isInitialized: boolean = false;
  public locale: string = (localStorage.language) ? localStorage.language : 'en';
  private _selectedColumns: Column[] = [];
  @ViewChild('importer', { static: false })
  public importer?: FileUpload;
  public importChooseLabel: string = 'Import';
  public importLabel: string = 'Import CSV';

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private common: CommonService,
    private router: Router,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private menusDataService: MenusDataService,
    private menusColumnsService: MenusColumnsService,
  ) {
    this.importChooseLabel = this.translate.instant('IMPORT');
    this.importLabel = this.translate.instant('IMPORTCSV');
    console.log('MenusComponent', 'ngOnInit');

  }

  ngOnInit(): void {
    console.log('MenusComponent', 'ngOnInit');
    this.isInitialized = true;
    this.titleService.setTitle('Menus - Management');
    this.primengConfig.ripple = true;
    this.getMenus();
  }

  ngOnDestroy(): void {
    console.log('MenusComponent', 'ngOnDestroy');
    this.isInitialized = false;
  }

  getMenus(): void {
    console.log('MenusComponent', 'getMenus');

    if (!this.isInitialized) {
      return;
    }
    if (parseInt(this.parameters.offset + '', 10) === 0) {
      this.isLoading = true;
    }
    this.menusDataService.getMenus(this.parameters).subscribe((response: MenusResult | any) => {
      console.log('response', 'response');

      this.isLoading = false;
      if (response !== null) {
        this.setColumns();
        if (parseInt(this.parameters.offset + '', 10) === 0) {
          this.menus = response.results;
        } else {
          this.menus = this.menus.concat(response.results);
        }
        if (response.inlineCount > this.menus.length) {
          this.parameters.offset = (parseInt(this.parameters.offset + '', 10) + parseInt(this.parameters.limit + '', 10)) + '';
          this.getMenus();
        } else {
          this.parameters.offset = '0';
        }
      }
    }, (error: any) => {
      ;
      this.isLoading = false;
      this.messageService.add({ severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('MenuSNOTLOADED') });
    });
  }

  importMenus(event: any): void {
    if (typeof event.currentFiles === 'undefined') {
      return;
    }
    if (event.currentFiles.length === 0) {
      return;
    }
    const inputFile = event.currentFiles[0];
    const reader = new FileReader();
    let rows: any[] = [];
    reader.onload = (e: any) => {
      if (typeof this.importer !== 'undefined') {
        this.importer.clear();
      }
      const text = <string>e.target.result;
      rows = ToolsService.csvToArray(this.columns, text, ',');
      if (rows.length > 0) {
        let proceed = 0;
        const j = rows.length;
        for (let i = 0; i < j; i += this.chunkSize) {
          this.isLoading = true;
          const chunk = rows.slice(i, i + this.chunkSize);
          if (typeof chunk[0].id === 'undefined') {
            this.menusDataService.addMenus(chunk).subscribe((response: any) => {
              this.isLoading = false;
              if (typeof response.length !== 'undefined') {
                proceed += response.length;
                this.messageService.add({ severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: proceed + ' ' + this.translate.instant('MenuSCREATED') });
                if (proceed === j) {
                  this.getMenus();
                }
              } else {
                this.messageService.add({ severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('MenuSNOTCREATED') });
              }
            }, (error: any) => {
              this.isLoading = false;
              console.warn('import error', error);
              let msg = '';
              if (typeof error.error.length !== 'undefined') {
                msg = error.error;
              } else if (typeof error.error.errors.errors.children !== 'undefined') {
                const children = error.error.errors.errors.children;
                for (const field in children) {
                  if (typeof children[field].errors !== 'undefined') {
                    msg += field + ' ' + children[field].errors.join(', ');
                  }
                }
              }
              this.messageService.add({ severity: 'warn', summary: this.translate.instant('ERROR'), detail: this.translate.instant('MenuSNOTCREATED') + ' ' + msg });
            });
          } else {
            this.menusDataService.updateMenus(chunk).subscribe((response: any) => {
              this.isLoading = false;
              if (typeof response.length !== 'undefined') {
                proceed += response.length;
                this.messageService.add({ severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: proceed + ' ' + this.translate.instant('MenuSUPDATED') });
                if (proceed === j) {
                  this.getMenus();
                }
              } else {
                this.messageService.add({ severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('MenuSNOTUPDATED') });
              }
            }, (error: any) => {
              this.isLoading = false;
              console.warn('import error', error);
              let msg = '';
              if (typeof error.error.length !== 'undefined') {
                msg = error.error;
              } else if (typeof error.error.errors.errors.children !== 'undefined') {
                const children = error.error.errors.errors.children;
                for (const field in children) {
                  if (typeof children[field].errors !== 'undefined') {
                    msg += field + ' ' + children[field].errors.join(', ');
                  }
                }
              }
              this.messageService.add({ severity: 'warn', summary: this.translate.instant('ERROR'), detail: this.translate.instant('MenuSNOTCREATED') + ' ' + msg });
            });
          }
        }
      }
    };
    reader.readAsText(inputFile);
  }

  setColumns() {
    if (this.columns.length > 0) {
      return;
    }
    this.columns = this.menusColumnsService.getColumns();
    for (let i = 0; i < this.columns.length; i++) {
      if (this.columns[i].show) {
        this._selectedColumns.push(this.columns[i]);
      }
    }
  }

  @Input()
  get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    // restore original order
    this._selectedColumns = this.columns.filter((col: any) => val.includes(col));
    this.updateColumns();
  }

  updateColumns() {
    for (let i = 0; i < this.columns.length; i++) {
      const show = this._selectedColumns.includes(this.columns[i]);
      this.columns[i].show = show;
      this.navigation.setParamValue('menus.' + this.columns[i].field + '.showFiled', show);
    }
  }

  deleteSelectedMenus() {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to delete the selected Menus?',
      message: this.translate.instant('AREYOUSURETODELETEDMenu'),
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.menusDataService.deleteMenus(this.selectedMenus).subscribe((response) => {
          if (response === null) {
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Successful', detail: this.translate.instant('MenuDELETED'), life: 3000 });
            this.getMenus();
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MenuNOTDELETED') });
          }
        }, (error: any) => {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MenuNOTDELETED') });
        });
        this.selectedMenus = [];
      }
    });
  }

  exportPdf() {
    ToolsService.exportPdf(this.menus, this.columns, 'Menus');
  }

  exportExcel() {
    ToolsService.exportExcel(this.menus, this.columns, 'Menus');
  }

  exportCsv() {
    ToolsService.exportCsv(this.menus, this.columns, 'Menus');
  }

  refresh() {
    this.menusDataService.clearCache();
    this.getMenus();
  }

  menuAdd(): void {
    if (!this.navigation.getParamValue('menus.addInDialog', true)) {
      this.router.navigate(['/menus/add']);
      return;
    }
    this.menuAddDialog = this.dialogService.open(DialogMenuFormComponent, {
      header: '', // this.translate.instant('NEWMenu'),
      width: '80%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        mode: 'add',
        menu: {id: null},
        users: this.menusColumnsService.users,
      },
    });

    this.menuAddDialog.onClose.subscribe((response: any) => {
      if (response && response.refresh) {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Success', detail: this.translate.instant('menuCREATED') });
        this.getMenus();
      }
    });
  }

  menuEdit(menu: Menu): void {
    if (!this.navigation.getParamValue('menus.editInDialog', true)) {
      this.router.navigate(['/menus/edit/' + menu.id]);
      return;
    }
    this.menuEditDialog = this.dialogService.open(DialogMenuFormComponent, {
      header: '', // this.translate.instant('EDITMenu') + ' ' + Menu.title,
      width: '70%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        mode: 'edit',
        menu: menu,
 
        users: this.menusColumnsService.users,
      },
    });

    this.menuEditDialog.onClose.subscribe((response: any) => {
      if (response && response.refresh) {
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate.instant('menuUPDATED') });
        this.getMenus();
      }
    });
  }

  menuDetails(menu: Menu): void {
    if (!this.navigation.getParamValue('menus.detailsInDialog', true)) {
      this.router.navigate(['/menus/details/' + menu.id]);
      return;
    }
    this.menuDetailsDialog = this.dialogService.open(DialogMenuDetailsComponent, {
      width: '70%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        menu: menu,
      }
    });
  }

  menuDelete(menu: Menu): void {
    this.menuToDelete = menu;
    this.messageService.clear();
    this.messageService.add({
      key: 'menuDelete',
      sticky: true,
      severity: 'warn',
      summary: this.translate.instant('AREYOUSURETODELETE') + menu.title + ' ?',
      detail: this.translate.instant('CONFIRMTOPROCCED')
    });
  }

  onDeleteConfirm(): void {
    this.menusDataService.deleteMenu(this.menuToDelete).subscribe((res: any) => {
      this.messageService.clear();
      this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate.instant('menuDELETED') });
      this.getMenus();
    }, (error: any) => {
      this.messageService.clear();
      this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('menuNOTDELETED') });
    });
  }

  onDeleteReject(): void {
    this.menuToDelete = {};
    this.messageService.clear('postDelete');
  }

}
